import { render, staticRenderFns } from "./UserLifecycle.vue?vue&type=template&id=533a61de&scoped=true"
import script from "./UserLifecycle.vue?vue&type=script&lang=js"
export * from "./UserLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a61de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533a61de')) {
      api.createRecord('533a61de', component.options)
    } else {
      api.reload('533a61de', component.options)
    }
    module.hot.accept("./UserLifecycle.vue?vue&type=template&id=533a61de&scoped=true", function () {
      api.rerender('533a61de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/UserLifecycle.vue"
export default component.exports